import styled, { css, keyframes } from 'styled-components';

const blink = keyframes`
0% {;
  }
  100% {
    text-shadow: 0 0 1px #ffffff, 0 0 2px #ffffff, 0 0 3px #0ba9ca,
        0 0 2px #0ba9ca, 0 0 4px #0ba9ca, 0 0 6px #0ba9ca;
  }
`;

export const NavMenu = styled.nav`
  padding: 0.7rem 1.2rem;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  display: none;
  z-index: 5;

  .overlay {
    background-color: none;
    border: 1px solid transparent;
    height: 100vh;
    width: 100%;
    top: 0;
    right: 0;
    position: absolute;
    transition: background 0.7s ease;
    transition-delay: 0s;
    transform: translateY(100%);
    ${({ navState }) =>
      navState &&
      css`
        background-color: rgba(0, 0, 0, 0.2);
        transform: translateY(0%);
      `}
  }

  .side-bar {
    width: 100px;
    height: 0px;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    top: 0;
    right: 0;
    padding-top: 3.5rem;
    background-color: #011a28;
    color: #fff;
    z-index: 7;
    overflow: hidden;
    transition: height 0.3s ease 0.7s, width 0.7s ease;

   

    .overlay-card {
      border: none;
      border-top: 0.9px solid #023047;
      border-bottom: 0.9px solid #023047;
      margin-top: -5rem;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .link-item {
        border-top: 1.8px solid #023047;
        border-bottom: 1.8px solid #023047;
        
        list-style: none;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 500;
        transition: all ease 0.4s;
        cursor: pointer;
        
        a {
          color: #fff;
          text-decoration: none;
          width: 100%;
          padding: 1.6rem;
          text-align: center;

        }

        &:hover {
          border-color: #3bcfe3;
          p {
            color: #3bcfe3;
          }
        }
        p {
          font-size: 1.1rem;
        }
      }
    }
    .home-text {
      padding: 2.2rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    ${({ navState }) =>
      navState &&
      css`
        height: 100vh;
        max-width: 20rem;
        width: 80%;
        transition: width 0.7s ease, height 0.3s ease;
      `}
    * + * {
      opacity: 0;
      display: none;
      transition: opacity 0.7s ease 0.4s;
      transition: opacity 0.7s ease 0.4s;
      ${({ navState }) =>
        navState &&
        css`
          opacity: 1;
          display: flex;
        `}
    }
  }


  .nav-icons {
    display: flex;
    justify-content: center;

      .icon-item {
        list-style: none;
        margin: 0 1rem;
        width: 1.2rem;
        height: 1.2rem;
        display: block;
        filter: invert(57%) sepia(7%) saturate(8%) hue-rotate(131deg)
        brightness(96%) contrast(90%);
        
        .icon-link {
          width: 1.2rem;
          height: 1.2rem;

        }

        &:hover {
          filter: invert(68%) sepia(73%) saturate(411%) hue-rotate(138deg)
            brightness(91%) contrast(95%);
        }
      }
  }
  button {
    margin-bottom: 1.7rem;
  }
  .resume-link {
    color: #3bcfe3;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 4px;
    font-family: sans-serif;
    text-decoration: none;
    padding: 10px 18px;
    display: block;
    border: 1px solid #3bcfe3;
    white-space: nowrap;
    // margin-bottom: 1.7rem;



    &:hover {
      color: #333;
    }
  }

  .logo {
    a {
      position: relative;
      z-index: 5;
      text-decoration: none;
      font-size: 1.6rem;
      color: #b4cfd3;
      text-shadow: 0 0 1px #ffffff, 0 0 2px #ffffff, 0 0 4px #0ba9ca,
        0 0 2px #0ba9ca, 0 0 4px #0ba9ca, 0 0 12px #0ba9ca;
      animation: ${blink} 2s infinite alternate;
    }
  }

  .navBtn-check {
    max-width: 20rem;
    width: 80%;
    display: flex;
    position: relative;
    transform: translateX(74%);
    z-index: 9;
    margin-right: -1.2rem;
    transition: all 0.7s ease;

    ${({ navState }) =>
      navState &&
      css`
        transform: translateX(0%);
        transition: all 0.7s ease 0s;
      `};
  }
  .navBtn {
    cursor: pointer;
    z-index: 9;
    transform: translateX(100%)
    position: relative;
    display: block;
    margin-left: 1rem;
    padding: 1.2rem .4rem 1.2rem .6rem;
    background: #011a28;
    border-radius: 3px;
    border: 2px solid ${({ navState }) =>
      navState ? 'transparent' : '#3bcfe3'};
  }

  .hamburger-menu {
    background: white;
    width: ${({ navState }) => (navState ? '2em' : '37px')};
    height: 4px;
    transition: background 0.3s;
    position: relative;
    display: block;
    margin: 0;
    transition: ${({ navState }) =>
      navState ? 'width 0.7s ease 0.7s' : 'width 0.3s ease'};
    z-index: 6;

    @media (max-width: 400px) {
      margin-left: -0.35em;
    }
    @media (max-width: 350px) {
      margin-left: -2em;
    }

    &:before,
    &:after {
      display: block;
      position: absolute;
      background: white;
      width: ${({ navState }) => (navState ? '1.2em' : '37px')};
      height: 4px;
      transition: background 0.3s;
      content: '';
      position: absolute;
      margin: -0.7em 0 0;
      transition: width 0.7s ease 0.3s, transform 0.7s ease 0.3s;
    }

    &:after {
      margin-top: -0.7em;

      ${({ navState }) =>
        navState &&
        css`
          width: 1.2em;
          transform: rotate(35deg);
          margin-top: -0.4em;
          right: 0;
        `}
    }
    &:before {
      margin-top: 0.7em;
      ${({ navState }) =>
        navState &&
        css`
          right: 0;
          width: 1.2em;
          transform: rotate(-35deg);
          margin-top: 0.4em;
        `}
    }
  }

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
